<style lang="scss" src='./Sensors.scss' scoped></style>
<template src="./Sensors.html"></template>

<script>
  import moment from 'moment';
  import sensorImg from '@/assets/sensor.png';
  import SensorDetails from '@/views/sensors/details/SensorDetails.vue';
  import {
    mapState,
    mapGetters,
    mapActions,
    mapMutations,
  } from 'vuex';

  // Hover text for the compact list's icons (component-local; falls back to gw-js-lib locales)
  const messages = {
    en: { sl: {
      thresholdAlert: 'Threshold alert: a recent reading is outside this sensor\'s limits',
      hidden: 'Hidden: customers don\'t see this sensor',
    } },
    es: { sl: {
      thresholdAlert: 'Alerta de umbral: una lectura reciente está fuera de los límites de este sensor',
      hidden: 'Oculto: los clientes no ven este sensor',
    } },
  };

  export default {
    name: 'Sensors',
    i18n: { messages },
    components: {
      SensorDetails,
    },
    data() {
      return {
        enviroment: process.env.VUE_APP_SENTRY_ENV,
        sensorImg,
        loading: {
          sensors: false,
        },
        currentSort: 'location_code',
        currentSortOrder: 'desc',
      };
    },
    computed: {
      ...mapState('sensors', {
        sensor: (state) => state.sensor,
        rssiIcon: (state) => state.rssiIcon,
        pagination: (state) => state.pagination,
      }),
      ...mapState(['course']),
      
      isCourseType(){
        if( (this.course.facility_type && this.course.facility_type.is_golf_course) 
        || !this.course.facility_type){
          return true;
        }else{
          return false;
        }
      },

      sensors: {
        get() {
          return this.customSensorSort(this.$store.state['sensors'].sensors);
        },
        set(value) {
          this.setSensors(value)
        }
      },
    },
    methods: {
      ...mapActions('sensors', ['apiGetSensors']),
      ...mapMutations('sensors', ['setSensor', 'setSensors', 'cleanSensor']),
      // "3 hours ago"; the exact date and time are in the hover
      ago(date) {
        const t = moment.utc(date);
        return t.isValid() ? t.fromNow() : '–';
      },
      customSensorSort(value) {

        if (this.currentSort != 'location_code') {
          return value.sort((a, b) => {
            const sortBy = this.currentSort;
            if (!a[sortBy] && !b[sortBy]) {
              return 0;
            }
            else if (a[sortBy] && !b[sortBy]) {
              return -1;
            } 
            else if (!a[sortBy] && b[sortBy]) {
              return 1;
            } 
            else {
              if (this.currentSortOrder === "desc") {
                return String(a[sortBy]).localeCompare(String(b[sortBy]));
              }
              return String(b[sortBy]).localeCompare(String(a[sortBy]));
            }
            return -1;
          });
        } else {
          return value.sort((a, b) => {
            const sortBy = this.currentSort;
            if (!a['hole_id'] && !b['hole_id']) {
              // no hole, order by location_code
              if (!a[sortBy] && !b[sortBy]) {
                return 0;
              }
              else if (a[sortBy] && !b[sortBy]) {
                return -1;
              } 
              else if (!a[sortBy] && b[sortBy]) {
                return 1;
              } 
              else {
                if (this.currentSortOrder === "desc") {
                  return String(a[sortBy]).localeCompare(String(b[sortBy]));
                }
                return String(b[sortBy]).localeCompare(String(a[sortBy]));
              }
            }
            else if (a['hole_id'] && !b['hole_id']) {
              return -1;
            } 
            else if (!a['hole_id'] && b['hole_id']) {
              return 1;
            } 
            else {
              const holeA = parseInt(a['hole']['hole_number']);
              const holeB = parseInt(b['hole']['hole_number']);

              if (holeA > holeB){
                if (this.currentSortOrder === "desc") {
                  return 1;
                }
                return -1;
              } else if (holeB > holeA) {
                if (this.currentSortOrder === "desc") {
                  return -1;
                }
                return 1;
              } else {
                if (this.currentSortOrder === "desc") {
                  return String(a[sortBy]).localeCompare(String(b[sortBy]));
                }
                return String(b[sortBy]).localeCompare(String(a[sortBy]));
              }
            }
            return -1;
          });
        }
      },
      getKeys(obj) {
        return Object.keys(obj);
      },
      selectSensor(sensor) {
        if (sensor) {
          this.setSensor({
            ...sensor
          });
        }
      },

      async loadData() {
        if (this.sensors.length === 0) {
          this.loading.sensors = true;
        }
        await this.apiGetSensors();
        if (this.sensors.length) {
          this.setSensor({
            ...this.sensors[0]
          });
        } else {
          this.cleanSensor();
        }
        this.loading.sensors = false;
      },
    },
    mounted() {
      if (process.env.VUE_APP_SENTRY_ENV == "production") {
        this.$analytics.setCurrentScreen("Web Sensors");
        this.$analytics.logEvent("web_sensors");
      }

      this.setSensor({});
      this.$parent.$on('courseChange', (val) => {
        if (val) {
          this.loadData();
        } else {
          this.sensors = [];
        }
      });
      this.loadData();
    },

    beforeDestroy() {
      this.cleanSensor();
      // Clean the selected sensor befor destroy componenet
    },
  };

</script>
